/* =========================================================
   PROPERDRY — Interactions
   ========================================================= */
(function () {
  'use strict';

  /* Signal JS is active so reveal animations can safely hide content first */
  document.documentElement.classList.add('js');

  /* ---- Header shadow on scroll ---- */
  var header = document.getElementById('header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile menu drawer ---- */
  var burger = document.getElementById('burger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (burger && mobileMenu) {
    var mmClose = document.getElementById('mmClose');
    var openMenu = function () {
      mobileMenu.classList.add('open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closeMenu = function () {
      mobileMenu.classList.remove('open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    burger.addEventListener('click', openMenu);
    if (mmClose) mmClose.addEventListener('click', closeMenu);
    mobileMenu.addEventListener('click', function (e) { if (e.target === mobileMenu) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.acc-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc');
      var answer = item.querySelector('.acc-a');
      var isOpen = item.classList.contains('open');
      // close siblings for a clean single-open accordion
      var group = item.parentElement;
      group.querySelectorAll('.acc.open').forEach(function (o) {
        if (o !== item) { o.classList.remove('open'); o.querySelector('.acc-a').style.maxHeight = null; }
      });
      if (isOpen) {
        item.classList.remove('open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
  // open the first one on load
  var firstOpen = document.querySelector('.acc.open .acc-a');
  if (firstOpen) firstOpen.style.maxHeight = firstOpen.scrollHeight + 'px';

  /* ---- Layer cards subtle parallax on hover ---- */
  var layers = document.getElementById('layers');
  if (layers && window.matchMedia('(hover:hover)').matches) {
    var cards = layers.querySelectorAll('.layer-card');
    layers.addEventListener('mousemove', function (e) {
      var r = layers.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5;
      cards.forEach(function (c, i) {
        var depth = (i + 1) * 3;
        c.style.transform = 'translateX(' + (dx * depth) + 'px)';
      });
    });
    layers.addEventListener('mouseleave', function () {
      cards.forEach(function (c) { c.style.transform = ''; });
    });
  }

  /* ---- Homepage bundle select -> nudge to product ---- */
  var cartCount = document.querySelector('.cart-count');
  document.querySelectorAll('.bundle-card .select-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.bundle-card');
      document.querySelectorAll('.bundle-card').forEach(function (c) { c.style.outline = 'none'; });
      card.style.outline = '2px solid var(--sage-2)';
      // In the real theme this routes to the product with the bundle preselected.
      window.location.href = 'product.html?bundle=' + card.getAttribute('data-bundle');
    });
  });

  /* ---- Add to cart -> popup « Opening your cart… » puis redirection vers /cart ----
     Repris tel quel de Fluxe & Co : l'article est ajouté en AJAX pendant qu'un
     popup avec spinner confirme le clic, puis on part sur la page /cart, qui est
     le panier (sections/main-cart.liquid). Il n'y a plus de tiroir. */
  (function () {
    /* Préfixe de marché ('/' sur la boutique principale, '/fr/' ailleurs) : sans
       lui l'ajout au panier renvoie le client vers la mauvaise langue/devise. */
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var I18N = {};
    try { I18N = JSON.parse(document.getElementById('cartI18n').textContent) || {}; } catch (e) {}
    function T(key, fallback) { return I18N[key] || fallback; }

    /* ---- Le popup de chargement ---- */
    var overlay = null;
    function ensureShell() {
      if (overlay) return overlay;
      overlay = document.createElement('div');
      overlay.className = 'pp-modal';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = '<div class="pp-modal__overlay"></div>' +
        '<div class="pp-modal__box" role="dialog" aria-live="polite">' +
          '<div class="pp-modal__stage"></div>' +
        '</div>';
      document.body.appendChild(overlay);
      return overlay;
    }
    /* Confirme le clic DANS le popup et le garde ouvert jusqu'à ce que la page
       /cart prenne le relais — évite le blanc entre le clic et le panier. */
    function showAdding(msg) {
      ensureShell();
      var stage = overlay.querySelector('.pp-modal__stage');
      if (stage) {
        stage.innerHTML = '<div class="pp-modal__loading"><span class="pp-modal__spinner"></span>' +
          '<div class="pp-modal__loading-txt">' + (msg || T('opening', 'Opening your cart…')) + '</div></div>';
      }
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
    }

    /* ---- Interception des formulaires « ajouter au panier » ---- */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (e.defaultPrevented) return;
      e.preventDefault();

      var btn = form.querySelector('[name=add]') || form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = T('adding', 'Adding…'); }
      showAdding(T('opening', 'Opening your cart…'));

      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function () { window.location.href = ROOT + 'cart'; })
        .catch(function () { window.location.href = ROOT + 'cart'; });
    });

    /* Le compteur de l'en-tête reste juste après un retour arrière navigateur
       (page servie depuis le cache, donc jamais re-rendue par Shopify). */
    window.addEventListener('pageshow', function (evt) {
      if (!evt.persisted) return;
      if (overlay) { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); }
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = c.item_count || 0; });
        })
        .catch(function () {});
    });
  })();

  /* ---- Expose a tiny cart helper for prototype pages ---- */
  window.PD = {
    addToCart: function (n) {
      if (!cartCount) return;
      var c = parseInt(cartCount.textContent, 10) || 0;
      cartCount.textContent = c + (n || 1);
    }
  };
})();
